export const forms = {

    initFile: () => {
        const fileInputs = document.querySelectorAll(".btn-file input[type='file']");

        fileInputs.forEach((fileInput) => {

            fileInput.addEventListener("change", (e) => {
                const inputEl = e.target;

                const files = inputEl.files;
                const numFiles = files ? files.length : 1;
                const label = inputEl.value.split("\\").pop().split("/").pop();

                const customEvent = new CustomEvent("fileselect", {
                    detail: { numFiles, label }
                });

                inputEl.dispatchEvent(customEvent);
            });

            fileInput.addEventListener("fileselect", (e) => {
                const { numFiles, label } = e.detail;

                const inputGroup = fileInput.closest(".input-group");
                const textInput = inputGroup ? inputGroup.querySelector("input[type='text']") : null;

                const log = numFiles > 1
                    ? numFiles + " fichiers sélectionnés"
                    : label;

                if (textInput) {
                    textInput.value = log;
                } else if (log) {
                    alert(log);
                }
            });
        });
    }
}
